import React from "react";
import { useRouter } from "next/router";
import variables from "@/common/globalVariables";
import SingleJobListing from "@/components/jobs/JobListing/SingleJobListing";
import { getJobsFromAPI, getJob } from "@/lib/backend";

import PageSection from "@/common/Layout/PageSection";

import JobsCards from "@/components/jobs/JobList/JobsListQuery";

const pageStyles = `background-color:${variables.mutedColor1};`;

const SingleJobView = (props) => {
  const router = useRouter();
  const { jid } = router.query;
  const jobId = extractJobId(jid);

  if (router.isFallback) {
    return <div>Loading...</div>;
  }

  return (
    <div
      className="singleJobRelatedContainer"
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
      }}
    >
      <div
        className="RelatedJobsContainer"
        style={{
          // lower all inner font scaling
          fontSize: "0.8em",
        }}
      >
        <div
          style={{
            padding: "10px",
            backgroundColor: variables.mutedColor2,
            color: variables.baseTextColor,
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          Related Jobs
        </div>

        <JobsCards
          location={props.jobData.location.name}
          jobId={jobId}
          // q={props.jobData.title}
        />
      </div>
      <PageSection styles={pageStyles} nopadding row notFullWidth>
        <div className="JobContainer">
          <SingleJobListing
            jobData={props.jobData}
            jobId={extractJobId(jobId ?? props.query.jid)}
            countView
          />
          <style jsx>
            {`
              .JobContainer {
                width: 100%;
                max-width: 970px;
                padding-top: 30px;
                margin: auto;
              }

              @media (max-width: 720px) {
                .JobContainer {
                  padding-top: 0;
                }
              }
            `}
          </style>
        </div>
      </PageSection>
    </div>
  );
}; //eof

export async function getStaticPaths() {
  const jobs = await getJobsFromAPI();
  const jobsPaths = jobs.map((job) => {
    const jobPath = `${job.title.replace(
      /[\W_]+/g,
      "-"
    )}-${job.location.name.replace(/[\W_]+/g, "-")}-${job.id}`;
    return { params: { jid: jobPath } };
  });
  return {
    paths: jobsPaths,
    fallback: true, // See the "fallback" section below
  };
}

export async function getStaticProps({ params }) {
  const { jid } = params;
  const jobId = extractJobId(jid);
  const jobData = await getJob(jobId);

  // console.log({ jobData });

  return {
    props: { jobData, jobId },
    revalidate: 1,
  };
}

function extractJobId(slug) {
  if (slug) {
    const slugParts = slug.split("-");
    const jobId = slugParts[slugParts.length - 1];
    return jobId;
  }
  return undefined;
}

export default SingleJobView;
